import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonSize } from '../../../shared/common/Button';

interface Props {
    retry: () => Promise<void>;
}

export const CopyDetailsErrorMessage: FC<Props> = ({ retry }) => {
    const { t } = useTranslation();

    return (
        <div className="copy-details-popup">
            <div className="error-message">
                <p>
                    {t('notifications.globalErrorResponse.tryAgain', {
                        msg: t('notifications.globalErrorResponse.errorMessage')
                    })}
                </p>
                <Button onClick={retry} text={t('retry')} icon={'autorenew'} size={ButtonSize.LARGE} />
            </div>
        </div>
    );
};
